import React, { useId } from "react";
import "./CoolCheckbox.css";

/**
 * Custom dark-theme checkbox with animated check mark.
 */
const CoolCheckbox = ({
  id = null,
  checked = false,
  onChange = null,
  disabled = false,
  label = null,
  title = null,
  className = "",
  children = null,
}) => {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <label
      className={`ls-check${disabled ? " is-disabled" : ""}${
        checked ? " is-checked" : ""
      }${className ? ` ${className}` : ""}`}
      title={title || undefined}
      htmlFor={inputId}
    >
      <input
        id={inputId}
        type="checkbox"
        className="ls-check__input"
        checked={Boolean(checked)}
        disabled={disabled}
        onChange={(e) => onChange?.(e)}
      />
      <span className="ls-check__box" aria-hidden="true">
        <svg
          className="ls-check__mark"
          viewBox="0 0 12 12"
          width="12"
          height="12"
        >
          <path
            d="M2.2 6.2L4.8 8.8L9.8 3.2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {label ? <span className="ls-check__label">{label}</span> : null}
      {children}
    </label>
  );
};

export default CoolCheckbox;
